import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const URL_GET_PLAN = process.env.REACT_APP_CLAROPAGOS_URL;
const TOKEN_URL_GET_PLAN = process.env.REACT_APP_CLAROPAGOS_TOKEN;

const getAllClients = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/clients', options);
};

const getAllPlans = () => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/plans/all', options);
};

const getClientById = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/clients/code/' + dataClientId, options);
};

const createClient = dataClient => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/clients', dataClient, options);
};

const createNewSite = dataClient => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/onboarding/add-new-site?service=' + dataClient.providerType, dataClient, options);
};

const updateClient = (dataClient, dataClientId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.put(NERTHUS + '/clients/' + dataClientId, dataClient, options);
};

const deleteClient = dataClientId => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.delete(NERTHUS + '/clients/code/' + dataClientId, options);
};

const getSuscripcionPlan = dataSuscripcionId => {
  //let {NERTHUS, options} = ConfigAxios();
  let options = {
    headers: {
        'Content-Type': 'application/json',
        'Authorization': TOKEN_URL_GET_PLAN
    }
  };
  return axios.get(URL_GET_PLAN + dataSuscripcionId, options);
};

const updatePlanClient = (dataClient, dataClientId) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.post(NERTHUS + '/clients/assignPlanByDate/code/' + dataClientId, dataClient, options);
};

const getMultiClients = (codesClients) => {
  let {NERTHUS, options} = ConfigAxios();
  return axios.get(NERTHUS + '/clients?filterBy=code&filterValue=[' + codesClients + ']', options);
};

const ClientCrudService = {
  getAllClients,
  getClientById,
  getAllPlans,
  createClient,
  updateClient,
  deleteClient,
  getSuscripcionPlan,
  updatePlanClient,
  getMultiClients,
  createNewSite
};

export default ClientCrudService;